import { useState } from "react";
import Loading from "./components/Loading";
import User from "./User";
import Layout from "./components/Layout";

function Setting() {
    const [isLoading] = useState(false)

    return (
        <Layout>
            <Loading isLoading={isLoading} />
            <div className='bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-6'>
                <div className='border-b border-gray-200 mb-4'>
                    <h3 className='text-base font-semibold text-gray-900 pb-2'>ตั้งค่าผู้ใช้งาน</h3>
                </div>
                <User />
            </div>
        </Layout>
    )
}

export default Setting
